import React from 'react';
import S from './FooterLegalLinks.styles';
const FooterLegalLinks = ({ items = [] }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.List, null, items.map(item => (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url }, item.text)))))));
};
export default FooterLegalLinks;
